import { c as _c } from "react/compiler-runtime";
import { Box, type BoxProps } from "@mui/material";
import React from "react";
type PanelWrapperProps = BoxProps;
export const PanelWrapper: React.FC<PanelWrapperProps> = t0 => {
  const $ = _c(10);
  let children;
  let restProps;
  let sx;
  if ($[0] !== t0) {
    ({
      children,
      sx,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = restProps;
    $[3] = sx;
  } else {
    children = $[1];
    restProps = $[2];
    sx = $[3];
  }
  let t1;
  if ($[4] !== sx) {
    t1 = {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      width: "100%",
      position: "relative",
      border: 1,
      borderColor: "divider",
      borderRadius: 2,
      ...sx
    };
    $[4] = sx;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== restProps || $[8] !== t1) {
    t2 = <Box sx={t1} {...restProps}>{children}</Box>;
    $[6] = children;
    $[7] = restProps;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};